import axiosInstance from './axios';

export interface Product {
  id: number;
  name: string;
}

export const productsApi = {
  getProducts: async () => {
    const response = await axiosInstance.get('/products');
    return response.data;
  },
}; 